var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { useParams } from 'react-router';
import { api, apiResolve, useApiPost } from '@sierralabs/core-ui';
export function useAssignEntity(props) {
    const { routeParam, tableName, relations } = props;
    const params = useParams();
    const id = routeParam ? params[routeParam] : undefined;
    const { data, isLoading, error, response, post } = useApiPost(`entities/${tableName}/${id}/assign`);
    const assignEntity = useCallback((entities, params = {}) => {
        console.log('[useAssignEntity]\n  assign: %s\n  entities: %o', [tableName].concat(relations || []).join(' -> '), entities);
        post(Object.assign({ entities, relations: relations || [] }, params));
    }, [post, relations, tableName]);
    return {
        entity: data,
        isAssigning: isLoading,
        assignError: error,
        response,
        assignEntity
    };
}
// same as useAssignEntity hook but assignEntity()
// returns the request and result promise instead
export function useAssignEntityAsync(props) {
    const { routeParam, tableName, relations } = props;
    const params = useParams();
    const id = routeParam ? params[routeParam] : undefined;
    const [state, setState] = useState({ isLoading: false });
    const { data, isLoading, error } = state;
    const assignEntity = useCallback((entities, params = {}) => {
        console.log('[useAssignEntity]\n  assign: %s\n  entities: %o', [tableName].concat(relations || []).join(' -> '), entities);
        setState(state => (Object.assign(Object.assign({}, state), { isLoading: true, error: undefined })));
        const request = api.post(`entities/${tableName}/${id}/assign`, Object.assign({ entities, relations: relations || [] }, params));
        const promise = (() => __awaiter(this, void 0, void 0, function* () {
            // set state after getting result
            const result = yield apiResolve(request);
            setState(state => {
                return Object.assign(Object.assign({}, state), { isLoading: false, data: result.data, error: result.error });
            });
            return result;
        }))();
        return { request, result: promise };
    }, [id, relations, tableName]);
    return { entity: data, isLoading, error, assignEntity, setState };
}
//# sourceMappingURL=useAssignEntity.js.map